import { Icon1C, type MenuItem } from '@direct-frontend/components';
import { isNotNullOrUndefined } from '#shared/lib/array';
import { type SupportedIntegrationSyncTypes, type SupportedIntegrationTypes } from '#shared/lib/integrations';
import { createSourceMenuItem } from '../lib/createSourceMenuItem';
import { isIntegrationSourceConnected } from '../lib/isIntegrationSourceConnected';
import { useIntegrationTypeData } from './useIntegrationTypeData';

export const useAvailableSourcesToChange = ({
    handleChangeSource,
    integrationType,
    syncType,
}: {
    handleChangeSource: (systemTypeToUpdate: SupportedIntegrationTypes) => Promise<void>;
    integrationType?: SupportedIntegrationTypes;
    syncType?: SupportedIntegrationSyncTypes;
}): MenuItem | undefined => {
    const { moySkladData, wildberriesData, ozonData, ymlData, yandexMarketData } = useIntegrationTypeData();

    const hasConnectedMoySklad = isIntegrationSourceConnected.moysklad(moySkladData);
    const hasConnectedYandexMarket = isIntegrationSourceConnected.yandex_market(yandexMarketData);
    const hasConnectedWildberries = isIntegrationSourceConnected.wildberries(wildberriesData);
    const hasConnectedOzon = isIntegrationSourceConnected.ozon(ozonData);
    const hasConnectedYml = isIntegrationSourceConnected.yml(ymlData);

    const menuItem = {
        key: 'to_change_source',
        content: 'Изменить источник данных',
        items: [] as MenuItem[],
    };

    if (!integrationType || !syncType) {
        return menuItem;
    }

    const wildberriesItem: MenuItem | null = createSourceMenuItem({
        isDisabledMenuItemForChoose: integrationType === 'wildberries' || !hasConnectedWildberries,
        handleChangeSource,
        type: 'wildberries',
    });

    const ozonItem: MenuItem | null = createSourceMenuItem({
        isDisabledMenuItemForChoose: integrationType === 'ozon' || !hasConnectedOzon,
        handleChangeSource,
        type: 'ozon',
    });

    const moyskladItem: MenuItem | null = createSourceMenuItem({
        isDisabledMenuItemForChoose: integrationType === 'moysklad' || !hasConnectedMoySklad,
        handleChangeSource,
        type: 'moysklad',
    });

    const ymlItem: MenuItem | null = createSourceMenuItem({
        isDisabledMenuItemForChoose: integrationType === 'yml' || !hasConnectedYml,
        handleChangeSource,
        type: 'yml',
    });

    const oneCItem: MenuItem | null =
        integrationType === '1C'
            ? null
            : {
                  value: '1c',
                  addonRight: <Icon1C size="24" />,
                  content: '1C',
                  onAction: () => handleChangeSource('1C'),
              };

    const yandexMarketItem: MenuItem | null = createSourceMenuItem({
        isDisabledMenuItemForChoose: integrationType === 'yandex_market' || !hasConnectedYandexMarket,
        handleChangeSource,
        type: 'yandex_market',
    });

    const items = [wildberriesItem, ozonItem, moyskladItem, oneCItem, ymlItem, yandexMarketItem].filter(
        isNotNullOrUndefined
    );

    if (!items.length) {
        return;
    }

    menuItem.items.push(...items);

    return menuItem;
};
